import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, EASE } from "./Reveal";

const PANEL_TRANSITION = { duration: 0.45, ease: EASE };
const PANEL_VARIANTS = { open: { height: "auto", opacity: 1 }, closed: { height: 0, opacity: 0 } };
const ICON_SIZE = 18;

const FaqItem = ({ index, q, a, open, onToggle, prefix }) => (
  <Reveal delay={index * 0.05}>
    <div className={`rounded-xl border transition-colors duration-300 ${open ? "bg-cream border-navy/25" : "bg-cream/60 border-navy/10 hover:border-navy/25"}`}>
      <h3>
        <button
          type="button"
          data-testid={`${prefix}-toggle-${index}`}
          aria-expanded={open}
          aria-controls={`${prefix}-panel-${index}`}
          onClick={onToggle}
          className="w-full flex items-center justify-between gap-6 text-left px-6 sm:px-8 py-6"
        >
          <span className="flex items-baseline gap-5">
            <span className="font-display text-sm text-navy/40 tabular-nums">{String(index + 1).padStart(2, "0")}</span>
            <span className="font-display text-xl sm:text-2xl text-navy leading-snug">{q}</span>
          </span>
          <span className={`grid place-items-center w-9 h-9 shrink-0 rounded-full border transition-all duration-300 ${open ? "bg-navy border-navy text-ivory rotate-45" : "border-navy/25 text-navy"}`}>
            <Plus size={ICON_SIZE} strokeWidth={1.5} />
          </span>
        </button>
      </h3>
      <motion.div
        id={`${prefix}-panel-${index}`}
        data-testid={`${prefix}-panel-${index}`}
        initial={false}
        animate={open ? "open" : "closed"}
        variants={PANEL_VARIANTS}
        transition={PANEL_TRANSITION}
        className="overflow-hidden"
      >
        <div className="px-6 sm:px-8 pb-7 pl-[4.25rem] sm:pl-[4.75rem] space-y-3">
          {a.map((p) => (
            <p key={p.slice(0, 30)} className="text-base leading-relaxed text-charcoal/80 max-w-2xl">{p}</p>
          ))}
        </div>
      </motion.div>
    </div>
  </Reveal>
);

export default function FaqAccordion({ items, prefix = "faq" }) {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <div className="space-y-4">
      {items.map((item, i) => (
        <FaqItem key={item.q} index={i} prefix={prefix} {...item} open={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? -1 : i)} />
      ))}
    </div>
  );
}
